import { CreatorlessCampaign } from '../types';

export const DEFAULT_CAMPAIGN_STATE: CreatorlessCampaign = {
  countries: [],
  gender: null,
  goLiveDate: null,
  name: '',
  package: 'm',
  zalandoLink: ''
};
